module.exports = __webpack_public_path__ + "static/2-92f1e62b65a156d203b60693b212f045.png";